import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { installErrorBuffer } from './lib/errorBuffer'

installErrorBuffer()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Service worker registration failed — app still works normally
    })
  })
}
